import { createApiErrorFromResponse } from "../api";
import { SSO_AUTH_API_PATHS } from "../auth-routes";
import { joinUrlPath } from "../url";
import { readApiErrorDetail, readOptionalStringToken } from "./response";
import type { SsoLogoutConfig } from "./types";

export async function requestOidcToken(
  ssoApiBaseUrl: string,
  fetchImpl: typeof fetch,
  params: URLSearchParams,
) {
  return fetchImpl(joinUrlPath(ssoApiBaseUrl, "/sso/token"), {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: params.toString(),
  });
}

export async function requestSsoLogout(config: SsoLogoutConfig, fetchImpl: typeof fetch = fetch) {
  const accessToken = readOptionalStringToken(config.getAccessToken?.(), {
    fieldName: "access_token",
    invalidCode: "sso.oidc_access_token_invalid",
    invalidMessage: "SSO access token has invalid type",
  });
  const headers: Record<string, string> = {};
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  const requestInit: RequestInit = {
    method: "POST",
    credentials: "include",
    headers,
  };
  const response = await fetchImpl(
    joinUrlPath(config.ssoApiBaseUrl, SSO_AUTH_API_PATHS.logout),
    requestInit,
  );
  if (!response.ok) {
    const detail = await readApiErrorDetail(response);
    throw createApiErrorFromResponse(response, detail);
  }
}

export async function logoutAndClearLocalSession(
  config: SsoLogoutConfig,
  fetchImpl: typeof fetch = fetch,
) {
  try {
    await requestSsoLogout(config, fetchImpl);
  } finally {
    config.clearLocalSession?.();
  }
}
